<template>
  <div>
    <HeadingBar v-if="loggedIn"></HeadingBar>
    <div v-if="shouldShowApp" id="app" class="main-layout" @click="onClick">
      <div class="main-container">
        <div v-if="loggedIn">
          <NotificationBar></NotificationBar>
          <NavBar v-if="!hiddenTabsAdminEdit"></NavBar>
        </div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/Commons/NavBar.vue';
import NotificationBar from '@/components/Commons/NotificationBar.vue';
import HeadingBar from '@/components/Commons/HeadingBar.vue';
import { mapGetters, mapState, mapActions } from 'vuex';
import EventBus from './utils/event-bus.js';
import ConfigService from './services/config.service';

export default {
  components: {
    NavBar,
    NotificationBar,
    HeadingBar
  },
  data: function() {
    return {};
  },
  computed: {
    ...mapState({
      profileData: (state) => state.profile.profileData
    }),
    ...mapGetters(['loggedIn']),
    shouldShowApp() {
      return (this.profileData && this.profileData.id) || window.location.pathname === '/login';
    },
    hiddenTabsAdminEdit() {
      const route = this.$route.name;
      return route === 'adminEdit';
    }
  },
  watch: {
    $route: {
      handler($route) {
        this.setPageTitle($route.meta.title);
      },
      Immediate: true
    }
  },
  async created() {
    this.setDomain();
    this.setPageTitle(this.$route.meta.title);
    await this.fetchLanguages();
    await this.fetchExtendedLanguages();
    await this.fetchCountries();
  },
  methods: {
    ...mapActions(['fetchCountries', 'fetchLanguages', 'fetchExtendedLanguages']),
    setPageTitle() {
      const title = this.$route.meta.title;
      document.title =
        title && this.$i18n.te(`pageTitles.${title}`)
          ? `Accounts | ${this.$i18n.t(`pageTitles.${title}`)}`
          : 'Accounts';
    },
    onClick($event) {
      EventBus.$emit('click', $event);
    },
    /**
     * Set the domain and the cookie domain in the app
     */
    setDomain() {
      const script = document.createElement('script');
      const startScriptComment = document.createComment('Iframes domain');
      script.type = 'text/plain';
      script.innerText = `document.domain='${ConfigService.domain}'`;
      document.head.appendChild(startScriptComment);
      document.head.appendChild(script);
    }
  }
};
</script>

<style lang="scss">
@import './scss/style.scss';
</style>
